//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import Money from '@motionelements/money';
import SubscribeStats from '../subscribe/SubscribeStats.vue';
import SubscribeHeroBanner from '../subscribe/SubscribeHeroBanner.vue';

export default {
  name: 'SubscribePromoHero',
  components: {
    SubscribeHeroBanner,
    SubscribeStats,
    SubscribePromoButton: () => import('./SubscribePromoButton.vue'),
    EmbedVideo: () => import('@motionelements/core/src/components/ui/embed/EmbedVideo.vue'),
  },
  props: {
    subscribePlanLink: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    videoUrl: {
      type: String,
      required: true,
    },
    discountPercent: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      getPlanBilledMonthly: 'subscription/getPlanBilledMonthly',
    }),
    fullMonthlyPrice() {
      return Money(this.getPlanBilledMonthly.priceMonthly).toFormat('$0,0');
    },
    discountMonthlyPrice() {
      return Money({
        amount: +this.getPlanBilledMonthly.priceMonthly.amount * (1 - this.discountPercent / 100),
        currency: this.getPlanBilledMonthly.priceMonthly.currency,
      }).toFormat('$0,0');
    },
  },
};
